import React from "react";
import { Markdown } from "../markdown";
export var makeFormattedRenderer = function (values, staticContent) {
    if (staticContent === void 0) { staticContent = []; }
    return function (_a) {
        var translation = _a.translation;
        return (React.createElement(Markdown, { source: translation, values: values, staticContent: staticContent }));
    };
};
